module.exports = __webpack_public_path__ + "4f910a6379ebfea3e52783cb5e4b7eb8.png";